import React from 'react'
import PropTypes from 'prop-types'

import BreadCrumbs from '../BreadCrumbs'

const Headers = ({
  items,
  onBackClick,
  rightElement,
  rightElementClass = '',
  headerText,
  headerClass = '',
  hideBreadCrumbs
}) => (
  <div className='d-flex flex-wrap justify-content-between mb-4 mb-md-0'>
    <div className='col-12 col-md'>
      <BreadCrumbs
        onBackClick={onBackClick}
        hideBreadCrumbs={hideBreadCrumbs}
        items={items}
      />
      {headerText && <h2 className={headerClass} style={{ wordBreak: 'break-all' }}>{headerText}</h2>}
    </div>

    {rightElement &&
      <div className={`col-12 col-md-auto text-start text-md-end ${rightElementClass}`}>
        {rightElement}
      </div>
    }
  </div>
)

Headers.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any),
  onBackClick: PropTypes.func,
  rightElement: PropTypes.any,
  rightElementClass: PropTypes.string,
  headerText: PropTypes.string,
  headerClass: PropTypes.string,
  hideBreadCrumbs: PropTypes.bool
}

export default Headers
